module.exports = __webpack_public_path__ + "static/media/21ECLAC10.60805109.jpg";